/* eslint-disable no-unused-vars */
import axios from 'axios';
import DealerItem from './components/dealer-item/DealerItem.vue';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: { DealerItem },
  data() {
    return {
      user: {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        role: 'seller',
        dealer: null,
        city_id: null,
        channel_id: null,
        comment: '',
        distributors_ids: [],
        dealers: [],
      },
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
        notEmpty: v => (!!v && v.length > 0) || 'Поле должно быть заполнено',
      },
      valid: false,
      profile: {},
      search: '',
      searchCity: '',
      searchInn: '',
      suggestions: [],
      isLoadingSuggest: false,
      isLoadingCompanies: false,
      cities: [],
      dealers: [],
    };
  },
  watch: {
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.$store.getters.ax.post('profiles/api/location/cities', { term: city, limit: 30 })
          .then((result) => {
            app.cities = result.data.cities;
          });
      }
    },
    searchInn(inn) {
      const app = this;
      if (inn && inn.length && (inn.length === 10 || inn.length === 12)) {
        app.$store.getters.ax.post('profiles/api/dealers/find-by-inn', { inn })
          .then((result) => {
            app.dealers = result.data.data;
          }).catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() { return this.type === 'sms_noprofile'; },
    isSmsProfileUnregistered() { return this.type === 'sms_profile_unregistered'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
    distributorsList() {
      return this.$store.state.profiles.distributorsList;
    },
    channelsList() {
      return this.$store.state.profiles.channelsList;
    },
    hasDealersAddr() {
      const list = this.user.dealers.length ? [...this.user.dealers] : [];
      return list.length
        && !list.filter(d => !d.obj?.house && !d.fact_address && !d.disabled).length;
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
            app.user.dealers = profile.dealers
              .map(d => ({
                ...d,
                obj: null,
                fact_address: d.fact_address || '',
                disabled: !!d.fact_address,
              }));
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        comment: '',
        dealer: null,
        dealers: [],
        role: 'seller',
        city_id: null,
        channel_id: null,
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        distributors_ids: [],

      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.searchCity = '';
      this.cities = [];
      this.dealers = [];

      this.Focus('regPhone');
    },
    ChangeDealerAddress(id, address, dadata) {
      const dealers = [...this.user.dealers];
      const changedDealer = dealers.find(d => d.id === id);
      if (changedDealer) {
        const list = dealers.map((d) => {
          if (id === d.id) {
            return {
              ...d,
              fact_address: address,
              obj: dadata,
            };
          }
          return d;
        });
        this.$set(this.$data.user, 'dealers', list);
      }
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
      }
      if (app.isSmsProfileUnregistered) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      if (app.isSmsProfileUnregistered) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async AutocompleteSearch(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.profile.address = sug.data;
          document.getElementById('address').focus();
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.$store.dispatch('profiles/GetDistributorsList');
    this.$store.dispatch('profiles/GetChannelsList');
    this.Focus('regPhone');
  },
};
